export const UsersPage: React.FC = () => (
  <section id="users" className="page-section">
    <div className="page-header">
      <div>
        <p className="page-eyebrow">Access</p>
        <h2 className="page-title">Users</h2>
        <p className="page-copy">Administrative access, role coverage, and operator management.</p>
      </div>
    </div>
    <div className="placeholder-grid">
      <article className="placeholder-card">
        <h3>Role Coverage</h3>
        <p>Represent admin, event manager, scanner, and viewer roles using the same vocabulary as the live portal.</p>
      </article>
      <article className="placeholder-card">
        <h3>Password Recovery</h3>
        <p>Anchor reset and credential support here so user management maps cleanly to the live system.</p>
      </article>
      <article className="placeholder-card">
        <h3>Audit Trail</h3>
        <p>Add login activity and permission changes once backend auditing is available.</p>
      </article>
    </div>
  </section>
);
